<template>
  <div id="trunk">
    <lead :headOption="headOption" />
    <main class="main">
      <div id="examine">
        <keep-alive include="examineHome">
          <router-view />
        </keep-alive>
      </div>
    </main>
    <foote />
  </div>
</template>
<script>
import lead from "@/components/common/head";
import foote from "@/components/common/footer";

export default {
  data() {
    return {
      // 顶部模块标题：
      headOption: {
        link: "/examine",
        title: "审批"
      },
    };
  },
  components: {
    lead,
    foote
  }
};
</script>
<style lang="scss">
.main {
  height: calc(100vh - 124px);
  padding: 25px 0 40px;
  box-sizing: border-box;
  #examine {
    margin: 0 auto;
    width: 1200px;
    height: 100%;
    font-family: MicrosoftYaHei;
    // overflow-X:hidden;
  }
}

.pointer {
  cursor: pointer;
}

.course-menunav a {
  display: block;
  line-height: 65px;
}

.el-dialog {
  .el-dialog__header {
    background-color: #338efc;
    padding: 8px 20px 8px;

    .el-dialog__title {
      color: #fff;
      font-size: 14px;
    }

    .el-dialog__headerbtn {
      top: 8px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 24px;
    }

    .el-dialog__headerbtn .el-dialog__close:hover {
      color: rgba(255, 255, 255, 0.8);
    }
  }

  .el-dialog__body {
    padding: 0;
  }

  .el-dialog__footer {
    padding: 30px 0;

    .dialog-footer {
      margin: 0 auto;
      width: 146px;

      .el-button {
        padding: 0;
        width: 68px;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        border: 0 none;

        &:first-child {
          color: #7c9bb8;
          background: #deefff;
        }
      }
    }
  }
}
</style>